<template>
    <div v-if="shouldShowTabPanel">
        <div v-if="roleName !== 'customer'" class="addInHiddenInView">
            <div class="tabs_button">
                <b>

                        <confirm-attendance-button
                            :button-confirm-status="bookingRemindersWithTechnician"
                            title="Confirm Booking"
                            class-div="confirm-btn"
                            :element-id="'custom_object_' + itemId"
                            :booking-id="itemId"
                        />

                </b>
            </div>
        </div>
        <div id="confirmation-info">
            <div v-if="bookingRemindersWithCustomer.length || bookingRemindersWithTechnician.length" class="white tab_padding float_none">
                <!-- Customer Section -->
                <div v-if="bookingRemindersWithCustomer && bookingRemindersWithCustomer.length">
                    <div class="tabs-details-label">
                        <h3 v-if="roleName !== 'customer'">Customer</h3>
                        <h3 v-else>Confirmation History</h3>
                    </div>
                    <ul class="disc_b" id="booking_discussion">
                        <li v-for="reminder in bookingRemindersWithCustomer"  v-if="reminder.comment" :key="reminder.id">
                            <div class="normal_font">
                                <span v-if="roleName !== 'customer'">
                                  <i class="fa fa-user"></i>   <b> {{ reminder.username }} wrote on </b>
                                </span>
                                <span>
                                  <i class="glyphicon glyphicon-time" aria-hidden="true"></i>
                                  <b v-if="roleName === 'customer'">{{ reminder.date }}</b>
                                  <span v-else>{{ reminder.date }}</span>
                                </span>
                            </div>
                            <div class="disc_message">{{ reminder.comment }}</div>
                        </li>
                    </ul>
                </div>
                <!-- Technician Section -->
                <div v-if="roleName !== 'customer' && bookingRemindersWithTechnician">
                    <h3>Technician</h3>
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>User</th>
                            <th>Comment</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="reminder in bookingRemindersWithTechnician" :key="reminder.id">
                            <td>{{ js_convert_timestamp_date_to_normal_date_format(reminder.created)  }}</td>
                            <td>{{ reminder.username }}</td>
                            <td>{{ reminder.comment }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!-- No Confirmation Message -->
                <div v-else>
                    <div class="inquiry-no-result">

                        <br />
                        <h3 class="font-bold"><span class="fa fa-ban"></span> No confirmation</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getSingleTabData} from "@/modules/Booking/api/BookingViewTabs";
import {EventBus} from "@/events/event-bus";

export default {
    name: "ConfirmationTab",
    props:{
        itemType: {
            type: String,
            required: true
        },
        itemId: {
            type: Number,
            required: true
        },
        credentials: {
            type: Object,
            default: () => ({}) // Default value is an empty object
        },
        view:'booking',
        estimatType: '',
    },
    data() {
        return {
            bookingRemindersWithCustomer: [],
            bookingRemindersWithTechnician: [],
             roleName: '', // This could be fetched from your user state or an API
        };
    },
    computed: {
        shouldShowTabPanel() {
            const isViewAllowed = ['complaint', 'inquiry', 'estimate'].includes(this.view);
            const isEstimateBookingView = this.view === 'estimate' && this.estimatType === 'booking';
            return (!isViewAllowed && this.credentials.bookingReminderAdd) || isEstimateBookingView;
        },

    },

    mounted() {
        this.fetchData();

        EventBus.$on('titleConfirmationChange', value=>{
             this.fetchData();
        });

    },
    methods: {
        fetchData() {
            let params = {
                type: "confirmation",
                booking_id: this.itemId,
                fromVuejs:true
            }
            getSingleTabData(params).then((response) => {
                this.bookingRemindersWithCustomer = response.data.bookingRemindersWithCustomer;
                this.bookingRemindersWithTechnician = response.data.bookingRemindersWithTechnician;
                this.roleName = response.data.bookingRemindersWithTechnician;
            })
        },
      js_convert_timestamp_date_to_normal_date_format(timestamp) {
         // Convert timestamp to milliseconds and create a Date object
        const date = new Date(timestamp * 1000);

        // To get a readable string
        const dateString = date.toDateString();
        return dateString ;
      },
    },
}
</script>

<style scoped>
.tabs_button {
  background-color: #FFFFFF;
}
.confirm-btn{
  border-radius: 8px !important;
  padding: 10px 10px !important;
  font-family: 'Roboto', serif !important;
  font-style: normal !important;
  font-weight: 500 !important;
  text-align: center !important;
  background-color: #008CFA !important;
  color: #FFFFFF !important;
  text-decoration: none !important;
}
</style>